import { useFiltersContext } from 'modules/dataWarehouse/contexts';
import { ModalAction } from 'modules/dataWarehouse/types';
import styled from 'styled-components';
import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Add16 } from 'ui/icons';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { InputText } from 'ui/inputs';
import { Menu } from 'ui/menu';
import { spacing } from 'ui/theme';
import { useModalContext } from 'utils/contexts/modal';
import { STATUS_FILTER_OPTIONS } from '../constants';
import { useBillingQueryContext } from '../contexts/BillingQueryContext';
import { shouldRestrictCreation } from '../utils';

export const PAGE_ACTIONS_TEXT = {
  clearFilterButtonId: 'clear-filters-button',
  clearFilterButtonLabel: 'Clear',
  createSyncButtonId: 'create-sync-button',
  createSyncButtonLabel: 'Connect a new source',
  searchId: 'search-input',
};

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const PageActions = () => {
  const { currentProjectStatus, remainingSyncs } = useBillingQueryContext();
  const { status, search, setSearch, setStatus } = useFiltersContext();
  const { showModal } = useModalContext();

  const handleChange = (val: string) => {
    const newValues = status.includes(val)
      ? status.filter((current) => current !== val)
      : [...status, val];
    setStatus(newValues);
  };

  const handleConnectSource = () => {
    const shouldRestrict = shouldRestrictCreation(currentProjectStatus, remainingSyncs);
    const action = shouldRestrict ? ModalAction.RESTRICT_CREATE : ModalAction.CONNECT_SOURCE;
    showModal({ action });
  };

  return (
    <ActionsRow>
      <Menu
        options={STATUS_FILTER_OPTIONS}
        defaultSelectedOptionIds={status}
        handleSelectionChange={handleChange}
        isSelectMenu
      >
        <FilterMenuTriggerButton selectedFilterCount={status.length} />
      </Menu>
      <InputText
        data-test={PAGE_ACTIONS_TEXT.searchId}
        placeholder="Search by sync name"
        type="search"
        value={search}
        onChange={setSearch}
      />
      <PrimaryButton
        data-test={PAGE_ACTIONS_TEXT.createSyncButtonId}
        onClick={handleConnectSource}
        size={BUTTON_SIZES.LARGE}
      >
        <Add16 />
        <span>{PAGE_ACTIONS_TEXT.createSyncButtonLabel}</span>
      </PrimaryButton>
    </ActionsRow>
  );
};
